import Axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL ?? "http://localhost:1337";

export const Api = Axios.create({
  baseURL: API_URL,
});
